import { service } from '../clients/HttpRpcImpl';
import { clearToken, DefaultTerminalInfo, saveToken } from '../utils/ls/token';
import Long from 'long';
import { live } from '../clients/proto';
import { clearServerAddress, saveServerAddress } from '../utils/ls/address';

export interface ConferenceConfig {
  domain?: string;
  token: string;
}

export default class ConferenceClient {
  config: ConferenceConfig;

  constructor(config: ConferenceConfig) {
    this.config = config;
    clearServerAddress();
    clearToken();
    saveToken(config.token);
    if (config.domain) {
      saveServerAddress(config.domain);
    }
  }

  async createRoom() {
    const response = await service.createRoom({
      terminalInfo: DefaultTerminalInfo,
      base: {
        extra: {
          UNIX_MS: new Date().getTime().toString(10),
        },
      },
    });
    return response;
  }

  async startRoom(terminalInfo: live.ITerminalInfo) {
    const unixTimestamps = new Date().getTime();
    const response = await service.startRoom({
      terminalInfo,
      base: {
        extra: {
          UNIX_MS: unixTimestamps.toString(10),
        },
      },
      unixTimestamps: Long.fromValue(unixTimestamps),
    });
    return response;
  }

  async deleteRoom(terminalInfo: live.ITerminalInfo) {
    const response = await service.deleteRoom({
      terminalInfo,
      base: {
        extra: {
          UNIX_MS: new Date().getTime().toString(10),
        },
      },
    });
    return response;
  }
}
